import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const ContainerInner = styled.div`
  max-width: ${props => props.width}px;
  width: 100%;
`;

export default ({ width, children }) => (
  <Container>
    <ContainerInner width={width}>{children}</ContainerInner>
  </Container>
);
